import { InputTextAreaProps } from "./input.types";
import { InputBase } from "./InputBase";

export const InputTextArea = (props: InputTextAreaProps) => (
  <InputBase {...props} renderAs="textarea" />
);
